import { NotificationTranslation, RouteNotifications } from '../types';

export const notificationTranslations: NotificationTranslation[] = [
    {
        key: 'api/authentication/error/session-timed-out',
        severity: 'failure',
        feature: 'actions'
    },
    {
        key: 'image-editor-firms/notification/error/unable-to-fetch-data',
        severity: 'failure',
        feature: 'actions'
    },
    {
        key: 'agreements/notification/agreement-added',
        severity: 'success',
        feature: 'agreements'
    },
    {
        key: 'agreements/notification/agreement-deleted',
        severity: 'success',
        feature: 'agreements'
    },
    {
        key: 'agreements/notification/agreement-updated',
        severity: 'success',
        feature: 'agreements'
    },
    {
        key: 'broker-tree/move/firm-keeps-own-agreement',
        severity: 'warning',
        feature: 'brokers/actions'
    },
    {
        key: 'broker-agent/create-message',
        severity: 'success',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/edit-message',
        severity: 'success',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/no-way-in/toast',
        severity: 'warning',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/password-link/copied',
        severity: 'success',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/password-link/copy-failed',
        severity: 'warning',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/password-link/email-sent',
        severity: 'success',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/password-link/email-sent-unknown-address',
        severity: 'success',
        feature: 'brokers/agent'
    },
    {
        key: 'broker-agent/password-link/error',
        severity: 'warning',
        feature: 'brokers/agent'
    },
    {
        key: 'brokers/chain/create-message',
        severity: 'success',
        feature: 'brokers/chain'
    },
    {
        key: 'brokers/chain/edit-message',
        severity: 'success',
        feature: 'brokers/chain'
    },
    {
        key: 'brokers/firm/create-message',
        severity: 'success',
        feature: 'brokers/firm'
    },
    {
        key: 'brokers/firm/edit-message',
        severity: 'success',
        feature: 'brokers/firm'
    },
    {
        key: 'brokers/firmgroup/create-message',
        severity: 'success',
        feature: 'brokers/firmGroup'
    },
    {
        key: 'brokers/firmgroup/edit-message',
        severity: 'success',
        feature: 'brokers/firmGroup'
    },
    {
        key: 'broker-tree/delete/success',
        severity: 'success',
        feature: 'brokers/tree'
    },
    {
        key: 'image-processing/notification/comment-updated',
        severity: 'success',
        feature: 'calendar'
    },
    {
        key: 'photographer-events/toastr/unbooking/error',
        severity: 'failure',
        feature: 'calendar'
    },
    {
        key: 'photographer-events/toastr/unbooking/success',
        severity: 'success',
        feature: 'calendar'
    },
    {
        key: 'common-texts/notification/common-text-added',
        severity: 'success',
        feature: 'commontexts'
    },
    {
        key: 'common-texts/notification/common-text-deleted',
        severity: 'success',
        feature: 'commontexts'
    },
    {
        key: 'impersonation/notification/impersonation-failed',
        severity: 'failure',
        feature: 'components'
    },
    {
        key: 'impersonation/notification/left-country-impersonation',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'impersonation/notification/left-impersonation',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'impersonation/notification/now-impersonating',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'impersonation/notification/now-impersonating-country',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'system/toastr/logged-in',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'system/toastr/logged-out',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'user-profile/error-update',
        severity: 'failure',
        feature: 'components'
    },
    {
        key: 'user-profile/success-update',
        severity: 'success',
        feature: 'components'
    },
    {
        key: 'copywriter/notification/added',
        severity: 'success',
        feature: 'copywriters'
    },
    {
        key: 'copywriter/notification/updated',
        severity: 'success',
        feature: 'copywriters'
    },
    {
        key: 'image-editor-firms/notification/image-editor-firm-added',
        severity: 'success',
        feature: 'imageeditorfirms'
    },
    {
        key: 'image-editor-firms/notification/image-editor-firm-updated',
        severity: 'success',
        feature: 'imageeditorfirms'
    },
    {
        key: 'image-editors/notification/user-created',
        severity: 'success',
        feature: 'imageeditors'
    },
    {
        key: 'image-editors/notification/user-deleted',
        severity: 'success',
        feature: 'imageeditors'
    },
    {
        key: 'image-editors/notification/user-updated',
        severity: 'success',
        feature: 'imageeditors'
    },
    {
        key: 'invoice-history/create-payment-modal/notification/payment-saved',
        severity: 'success',
        feature: 'invoice'
    },
    {
        key: 'invoice/payments/import/feedback/ok',
        severity: 'success',
        feature: 'invoice'
    },
    {
        key: 'invoice-product-type/modal/notification/invoice-product-type-created',
        severity: 'success',
        feature: 'invoiceProductType'
    },
    {
        key: 'invoice-product-type/modal/notification/invoice-product-type-edited',
        severity: 'success',
        feature: 'invoiceProductType'
    },
    {
        key: 'legalentities/notification/legal-entity-added',
        severity: 'success',
        feature: 'legalentities'
    },
    {
        key: 'legalentities/notification/legal-entity-deleted',
        severity: 'success',
        feature: 'legalentities'
    },
    {
        key: 'legalentities/notification/legal-entity-updated',
        severity: 'success',
        feature: 'legalentities'
    },
    {
        key: 'order/create/pickup-dialog/toaster-cancel',
        severity: 'info',
        feature: 'orders/createOrder'
    },
    {
        key: 'order/create/pickup-dialog/toaster-confirm',
        severity: 'success',
        feature: 'orders/createOrder'
    },
    {
        key: 'orders/notification/missing-key-pickup-address',
        severity: 'failure',
        feature: 'orders/createOrder'
    },
    {
        key: 'orders/list/advance/toast/info/has-saved-filter',
        severity: 'info',
        feature: 'orders/list'
    },
    {
        key: 'photographer-mail-modal/error',
        severity: 'failure',
        feature: 'orders/listunbookedordersV2'
    },
    {
        key: 'photographer-mail-modal/success',
        severity: 'success',
        feature: 'orders/listunbookedordersV2'
    },
    {
        key: 'sms-modal/error',
        severity: 'failure',
        feature: 'orders/listunbookedordersV2'
    },
    {
        key: 'sms-modal/success',
        severity: 'success',
        feature: 'orders/listunbookedordersV2'
    },
    {
        key: 'order/create/pickup-dialog/toaster-cancel',
        severity: 'info',
        feature: 'orders/scandphotos'
    },
    {
        key: 'order/create/pickup-dialog/toaster-confirm',
        severity: 'success',
        feature: 'orders/scandphotos'
    },
    {
        key: 'scandphotos/orders/create/toastr/error',
        severity: 'failure',
        feature: 'orders/scandphotos'
    },
    {
        key: 'scandphotos/orders/create/toastr/success',
        severity: 'success',
        feature: 'orders/scandphotos'
    },
    {
        key: 'orders/create/booking-request-confirmation/body1',
        severity: 'success',
        feature: 'orders/utils'
    },
    {
        key: 'orders/create/booking-request-confirmation/body2',
        severity: 'success',
        feature: 'orders/utils'
    },
    {
        key: 'orders/create/booking-request-confirmation/title',
        severity: 'success',
        feature: 'orders/utils'
    },
    {
        key: 'orders/notification/order-created',
        severity: 'success',
        feature: 'orders/utils'
    },
    {
        key: 'dropzone/invalid-filetype',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'dropzone/valid-file-unvalid-file-extension',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'generic-order/toastr/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/delete-multiple/error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/delete-multiple/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/download-images/error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/download-images/started',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/update-category/error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/button-label/update-category/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/deliver/notification/delivery-saved',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/deliver/notification/redelivery-saved',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/deliver/notification/scheduled-delivery-overridden',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/edited/file-upload/failed/text',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/edited/file-upload/failed/title',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/edited/normal-upload/message/done',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/modal/delete-edited-photo/delete/message',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/modal/notification/return-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/comment-updated',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/does-not-exist-on-order',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/does-not-exist-on-order',
        severity: 'warning',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/file-name-does-not-exist',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/images-uploaded',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/mail-sent',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/stitch-images/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/you-can-only-upload-one-image-at-a-time',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/notification/you-do-not-have-permission-to-upload-images',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/page/fail-update-sort-order',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/page/status-actions/notification/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'image-processing/page/status-actions/photographer-retrieved-order',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin-planorder/reset-scheduled-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin-planorder/reset-scheduled-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin/email-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin/email-files-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin/email-files-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/admin/email-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delete-storey/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delivery-file/removed-successfully',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delivery/email-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delivery/email-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delivery/external-file-removed-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/delivery/return-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/error/delete',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/error/planorder',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/error/reset-planorder',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/error/sort',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/error/storey',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/save-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/send-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/swap/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/update-startdate/failure',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'order/plan/update-startdate/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'photographer-uploads/notification/upload-done',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/approve-plan-order-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/change-plan-editor-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/change-plan-editor-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/change-plan-firm-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/change-plan-firm-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/connected-cubi-casa-order-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/connected-cubi-casa-order-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/cubi-casa-info/modal/invalid-guid',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/deleted-cubi-casa-order-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/deleted-cubi-casa-order-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/deliver-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/external-file-removed-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/generate-files-failed',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/generate-files-nothing-new',
        severity: 'warning',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/generate-files-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/grab-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/return/broker-failure',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/return/broker-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/return/roomsketcher-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/return/sketchup-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/return/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/returned-cubi-casa-order-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/returned-cubi-casa-order-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/roomsketcher-status-was-updated-successfully',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/send-to-plan-firm-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/send-to-plan-firm-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/sketchup-status-was-updated-successfully',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/sync-cubi-casa-order-error',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/sync-cubi-casa-order-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/update-placements-failed',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/admin-planorder/update-placements-success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/basic-order-info/products/notifications/photographer-cant-handle-product',
        severity: 'warning',
        feature: 'orders/view'
    },
    {
        key: 'view-order/basic-order-info/products/notifications/updated',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/basic-order/modal/create-email/success-notification',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/basic-order/modal/create-sms/success-notification',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/copy-info/copywriter/selector/changed-copywriter',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/copy-info/copywriter/selector/copywriter-reset',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'view-order/move/failure',
        severity: 'failure',
        feature: 'orders/view'
    },
    {
        key: 'view-order/move/success',
        severity: 'success',
        feature: 'orders/view'
    },
    {
        key: 'scandphotos/photographerbooking/toastr/error',
        severity: 'failure',
        feature: 'photographerBooking/scandphotos'
    },
    {
        key: 'scandphotos/photographerbooking/toastr/success',
        severity: 'success',
        feature: 'photographerBooking/scandphotos'
    },
    {
        key: 'orders/notification/order-created',
        severity: 'success',
        feature: 'photographerBooking/se360'
    },
    {
        key: 'orders/notification/traveling-time-warning',
        severity: 'warning',
        feature: 'photographerBooking/se360'
    },
    {
        key: 'se360/photographerbooking/page/toastr/success',
        severity: 'success',
        feature: 'photographerBooking/se360'
    },
    {
        key: 'calendars/photographer-items/update/toastr/success',
        severity: 'success',
        feature: 'photographerCalendars'
    },
    {
        key: 'calendars/photographer-working-hours/update/toastr/success',
        severity: 'success',
        feature: 'photographerCalendars'
    },
    {
        key: 'photographer-mail-modal/error',
        severity: 'failure',
        feature: 'photographerCalendars'
    },
    {
        key: 'photographer-mail-modal/success',
        severity: 'success',
        feature: 'photographerCalendars'
    },
    {
        key: 'sms-modal/error',
        severity: 'failure',
        feature: 'photographerCalendars'
    },
    {
        key: 'sms-modal/success',
        severity: 'success',
        feature: 'photographerCalendars'
    },
    {
        key: 'portfolio/server-images-error',
        severity: 'failure',
        feature: 'photographerPortfolio'
    },
    {
        key: 'calendars/photographer-items/update/toastr/success',
        severity: 'success',
        feature: 'photographers'
    },
    {
        key: 'calendars/photographer-working-hours/update/toastr/success',
        severity: 'success',
        feature: 'photographers'
    },
    {
        key: 'create-photographer-success',
        severity: 'success',
        feature: 'photographers'
    },
    {
        key: 'photographer/modal/update/success',
        severity: 'success',
        feature: 'photographers'
    },
    {
        key: 'photographers/calendar/toastr/error',
        severity: 'failure',
        feature: 'photographers'
    },
    {
        key: 'photographer-uploads/notification/upload-done',
        severity: 'success',
        feature: 'photographerupload'
    },
    {
        key: 'dropzone/invalid-filetype',
        severity: 'failure',
        feature: 'photographerupload/list'
    },
    {
        key: 'photographer-upload/notification/error/has-already-been-added-to-order-row',
        severity: 'failure',
        feature: 'photographerupload/list'
    },
    {
        key: 'unedited-orders/toastr/error',
        severity: 'failure',
        feature: 'photoorderlists'
    },
    {
        key: 'plan/annotation/delivery-file/customer-errors/crop',
        severity: 'failure',
        feature: 'planannotation'
    },
    {
        key: 'plan/annotation/external-file/customer-errors/crops',
        severity: 'failure',
        feature: 'planannotation'
    },
    {
        key: 'plan/annotation/external-file/errors/crops',
        severity: 'failure',
        feature: 'planannotation'
    },
    {
        key: 'plans/annotation/notifications/floor-successful-save',
        severity: 'success',
        feature: 'planannotation'
    },
    {
        key: 'plans/annotation/notifications/successful-save',
        severity: 'success',
        feature: 'planannotation'
    },
    {
        key: 'planeditor/orders/list/grab-error',
        severity: 'failure',
        feature: 'planeditorOrders'
    },
    {
        key: 'order/plan/delivery-file/removed-successfully',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'order/plan/error/delete',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'order/plan/error/sort',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'order/plan/error/storey',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/approve-plan-order-success',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/generate-files-failed',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/generate-files-nothing-new',
        severity: 'warning',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/generate-files-success',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/plan-editor/confirmation/error',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/plan-editor/confirmation/plan-editor-admin/success',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'planeditor/orders/edit/plan-editor/confirmation/success',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'view-order/admin-planorder/update-placements-failed',
        severity: 'failure',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'view-order/admin-planorder/update-placements-success',
        severity: 'success',
        feature: 'planeditorOrders/edit'
    },
    {
        key: 'plan-editors/notification/added',
        severity: 'success',
        feature: 'planeditors'
    },
    {
        key: 'plan-editors/notification/deleted',
        severity: 'success',
        feature: 'planeditors'
    },
    {
        key: 'plan-editors/notification/updated',
        severity: 'success',
        feature: 'planeditors'
    },
    {
        key: 'plan-firm-deleted',
        severity: 'success',
        feature: 'planfirms'
    },
    {
        key: 'plan-firms/notification/plan-firm-added',
        severity: 'success',
        feature: 'planfirms'
    },
    {
        key: 'plan-firms/notification/plan-firm-updated',
        severity: 'success',
        feature: 'planfirms'
    },
    {
        key: 'plan-templates/notification/error-file-upload',
        severity: 'failure',
        feature: 'plantemplates'
    },
    {
        key: 'plan-templates/notification/plan-template-added',
        severity: 'success',
        feature: 'plantemplates'
    },
    {
        key: 'plan-templates/notification/plan-template-deleted',
        severity: 'success',
        feature: 'plantemplates'
    },
    {
        key: 'plan-templates/notification/plan-template-updated',
        severity: 'success',
        feature: 'plantemplates'
    },
    {
        key: 'product-groups/notification/product-group-added',
        severity: 'success',
        feature: 'productGroups'
    },
    {
        key: 'product-groups/notification/product-group-deleted',
        severity: 'success',
        feature: 'productGroups'
    },
    {
        key: 'product-groups/notification/product-group-updated',
        severity: 'success',
        feature: 'productGroups'
    },
    {
        key: 'product-type-deleted',
        severity: 'success',
        feature: 'producttypes'
    },
    {
        key: 'product-types/notification/product-type-added',
        severity: 'success',
        feature: 'producttypes'
    },
    {
        key: 'product-types/notification/product-type-updated',
        severity: 'success',
        feature: 'producttypes'
    },
    {
        key: 'profile/page/notification/profile-saved',
        severity: 'success',
        feature: 'profile'
    },
    {
        key: 'create-region-success',
        severity: 'success',
        feature: 'regions/create'
    },
    {
        key: 'edit-region/notification/region-updated',
        severity: 'success',
        feature: 'regions/edit'
    },
    {
        key: 'se360-users/notification/user-deleted',
        severity: 'success',
        feature: 'se360users'
    },
    {
        key: 'se360-users/notification/user-restored',
        severity: 'success',
        feature: 'se360users'
    },
    {
        key: 'se360users/notification/user-added',
        severity: 'success',
        feature: 'se360users'
    },
    {
        key: 'se360users/notification/user-updated',
        severity: 'success',
        feature: 'se360users'
    },
    {
        key: 'special-authorizations/notification/update-succeeded',
        severity: 'success',
        feature: 'se360users/specialauthorizations'
    },
    {
        key: 'statistics/page/export/toastr/error',
        severity: 'failure',
        feature: 'statistics'
    },
    {
        key: 'statistics/page/export/toastr/no-results',
        severity: 'warning',
        feature: 'statistics'
    },
    {
        key: 'calendars/photographer-items/update/toastr/success',
        severity: 'success',
        feature: 'stylingCalendars'
    },
    {
        key: 'styling-firms/notification/error/unable-to-fetch-data',
        severity: 'failure',
        feature: 'stylingfirms'
    },
    {
        key: 'styling-firms/notification/styling-firm-added',
        severity: 'success',
        feature: 'stylingfirms'
    },
    {
        key: 'styling-firms/notification/styling-firm-updated',
        severity: 'success',
        feature: 'stylingfirms'
    },
    {
        key: 'calendars/photographer-items/update/toastr/success',
        severity: 'success',
        feature: 'stylingUserPersonalCalendars'
    },
    {
        key: 'photographers/calendar/toastr/error',
        severity: 'failure',
        feature: 'stylingUserPersonalCalendars'
    },
    {
        key: 'photographers/calendar/toastr/success',
        severity: 'success',
        feature: 'stylingUserPersonalCalendars'
    },
    {
        key: 'styling-user/notification/added',
        severity: 'success',
        feature: 'stylingusers'
    },
    {
        key: 'styling-user/notification/updated',
        severity: 'success',
        feature: 'stylingusers'
    },
    {
        key: 'styling-users/notification/error/unable-to-fetch-data',
        severity: 'failure',
        feature: 'stylingusers'
    },
    {
        key: 'zentuvo-invoicing/error/no-results-found',
        severity: 'failure',
        feature: 'zentuvoInvoicing/hooks'
    }
];

export const headerNotificationKeys: string[] = [
    'generic-order/toastr/success',
    'impersonation/notification/impersonation-failed',
    'impersonation/notification/left-country-impersonation',
    'impersonation/notification/left-impersonation',
    'impersonation/notification/now-impersonating',
    'impersonation/notification/now-impersonating-country',
    'portfolio/server-images-error',
    'system/toastr/logged-in',
    'system/toastr/logged-out',
    'user-profile/error-update',
    'user-profile/success-update'
];

export const routeNotifications: RouteNotifications[] = [
    {
        path: '/',
        exact: true,
        keys: []
    },
    {
        path: '/no-access',
        exact: false,
        keys: []
    },
    {
        path: '/no-access-brokersystem',
        exact: false,
        keys: []
    },
    {
        path: '/user-not-found',
        exact: false,
        keys: []
    },
    {
        path: '/se360users',
        exact: false,
        keys: [
            'se360-users/notification/user-deleted',
            'se360-users/notification/user-restored',
            'se360users/notification/user-added',
            'se360users/notification/user-updated',
            'special-authorizations/notification/update-succeeded'
        ]
    },
    {
        path: '/imageeditors',
        exact: false,
        keys: [
            'image-editors/notification/user-created',
            'image-editors/notification/user-deleted',
            'image-editors/notification/user-updated'
        ]
    },
    {
        path: '/products',
        exact: false,
        keys: []
    },
    {
        path: '/planfirms',
        exact: false,
        keys: [
            'plan-firm-deleted',
            'plan-firms/notification/plan-firm-added',
            'plan-firms/notification/plan-firm-updated'
        ]
    },
    {
        path: '/producttypes',
        exact: false,
        keys: [
            'product-type-deleted',
            'product-types/notification/product-type-added',
            'product-types/notification/product-type-updated'
        ]
    },
    {
        path: '/productgroups',
        exact: false,
        keys: [
            'product-groups/notification/product-group-added',
            'product-groups/notification/product-group-deleted',
            'product-groups/notification/product-group-updated'
        ]
    },
    {
        path: '/regions',
        exact: false,
        keys: ['create-region-success', 'edit-region/notification/region-updated']
    },
    {
        path: '/photographers/:id?',
        exact: false,
        keys: [
            'calendars/photographer-items/update/toastr/success',
            'calendars/photographer-working-hours/update/toastr/success',
            'create-photographer-success',
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'photographer/modal/update/success',
            'photographers/calendar/toastr/error'
        ]
    },
    {
        path: '/brokers/:nodeId?',
        exact: false,
        keys: [
            'broker-agent/create-message',
            'broker-agent/edit-message',
            'broker-agent/no-way-in/toast',
            'broker-agent/password-link/copied',
            'broker-agent/password-link/copy-failed',
            'broker-agent/password-link/email-sent',
            'broker-agent/password-link/email-sent-unknown-address',
            'broker-agent/password-link/error',
            'broker-tree/delete/success',
            'broker-tree/move/firm-keeps-own-agreement',
            'brokers/chain/create-message',
            'brokers/chain/edit-message',
            'brokers/firm/create-message',
            'brokers/firm/edit-message',
            'brokers/firmgroup/create-message',
            'brokers/firmgroup/edit-message'
        ]
    },
    {
        path: '/agreements',
        exact: false,
        keys: [
            'agreements/notification/agreement-added',
            'agreements/notification/agreement-deleted',
            'agreements/notification/agreement-updated'
        ]
    },
    {
        path: '/customer-agreements',
        exact: false,
        keys: []
    },
    {
        path: '/customer-calendar',
        exact: false,
        keys: []
    },
    {
        path: '/planeditors',
        exact: false,
        keys: [
            'plan-editors/notification/added',
            'plan-editors/notification/deleted',
            'plan-editors/notification/updated'
        ]
    },
    {
        path: '/legalentities',
        exact: false,
        keys: [
            'legalentities/notification/legal-entity-added',
            'legalentities/notification/legal-entity-deleted',
            'legalentities/notification/legal-entity-updated'
        ]
    },
    {
        path: '/photographer-uploads',
        exact: false,
        keys: [
            'dropzone/invalid-filetype',
            'photographer-upload/notification/error/has-already-been-added-to-order-row',
            'photographer-uploads/notification/upload-done'
        ]
    },
    {
        path: '/orders/registration-info',
        exact: false,
        keys: []
    },
    {
        path: '/orders/new/:orderCollectionId?',
        exact: false,
        keys: [
            'order/create/pickup-dialog/toaster-cancel',
            'order/create/pickup-dialog/toaster-confirm',
            'orders/create/booking-request-confirmation/body1',
            'orders/create/booking-request-confirmation/body2',
            'orders/create/booking-request-confirmation/title',
            'orders/notification/missing-key-pickup-address',
            'orders/notification/order-created'
        ]
    },
    {
        path: '/orders/clone/:orderId',
        exact: false,
        keys: [
            'orders/create/booking-request-confirmation/body1',
            'orders/create/booking-request-confirmation/body2',
            'orders/create/booking-request-confirmation/title',
            'orders/notification/order-created'
        ]
    },
    {
        path: '/orders',
        exact: true,
        keys: ['orders/list/advance/toast/info/has-saved-filter']
    },
    {
        path: '/orders/:orderId',
        exact: false,
        keys: [
            'api/authentication/error/session-timed-out',
            'broker-agent/create-message',
            'broker-agent/edit-message',
            'broker-agent/no-way-in/toast',
            'broker-agent/password-link/copied',
            'broker-agent/password-link/copy-failed',
            'broker-agent/password-link/email-sent',
            'broker-agent/password-link/email-sent-unknown-address',
            'broker-agent/password-link/error',
            'brokers/firm/create-message',
            'brokers/firm/edit-message',
            'dropzone/invalid-filetype',
            'dropzone/valid-file-unvalid-file-extension',
            'image-editor-firms/notification/error/unable-to-fetch-data',
            'image-processing/button-label/delete-multiple/error',
            'image-processing/button-label/delete-multiple/success',
            'image-processing/button-label/download-images/error',
            'image-processing/button-label/download-images/started',
            'image-processing/button-label/update-category/error',
            'image-processing/button-label/update-category/success',
            'image-processing/deliver/notification/delivery-saved',
            'image-processing/deliver/notification/redelivery-saved',
            'image-processing/deliver/notification/scheduled-delivery-overridden',
            'image-processing/edited/file-upload/failed/text',
            'image-processing/edited/file-upload/failed/title',
            'image-processing/edited/normal-upload/message/done',
            'image-processing/modal/delete-edited-photo/delete/message',
            'image-processing/modal/notification/return-success',
            'image-processing/notification/comment-updated',
            'image-processing/notification/does-not-exist-on-order',
            'image-processing/notification/file-name-does-not-exist',
            'image-processing/notification/images-uploaded',
            'image-processing/notification/mail-sent',
            'image-processing/notification/stitch-images/success',
            'image-processing/notification/you-can-only-upload-one-image-at-a-time',
            'image-processing/notification/you-do-not-have-permission-to-upload-images',
            'image-processing/page/fail-update-sort-order',
            'image-processing/page/status-actions/notification/success',
            'image-processing/page/status-actions/photographer-retrieved-order',
            'order/plan/admin-planorder/reset-scheduled-error',
            'order/plan/admin-planorder/reset-scheduled-success',
            'order/plan/admin/email-error',
            'order/plan/admin/email-files-error',
            'order/plan/admin/email-files-success',
            'order/plan/admin/email-success',
            'order/plan/delete-storey/success',
            'order/plan/delivery-file/removed-successfully',
            'order/plan/delivery/email-error',
            'order/plan/delivery/email-success',
            'order/plan/delivery/external-file-removed-success',
            'order/plan/delivery/return-success',
            'order/plan/error/delete',
            'order/plan/error/planorder',
            'order/plan/error/reset-planorder',
            'order/plan/error/sort',
            'order/plan/error/storey',
            'order/plan/save-success',
            'order/plan/send-success',
            'order/plan/swap/success',
            'order/plan/update-startdate/failure',
            'order/plan/update-startdate/success',
            'photographer-upload/notification/error/has-already-been-added-to-order-row',
            'photographer-uploads/notification/upload-done',
            'plan/annotation/delivery-file/customer-errors/crop',
            'plan/annotation/external-file/customer-errors/crops',
            'plan/annotation/external-file/errors/crops',
            'plans/annotation/notifications/floor-successful-save',
            'plans/annotation/notifications/successful-save',
            'view-order/admin-planorder/approve-plan-order-success',
            'view-order/admin-planorder/change-plan-editor-error',
            'view-order/admin-planorder/change-plan-editor-success',
            'view-order/admin-planorder/change-plan-firm-error',
            'view-order/admin-planorder/change-plan-firm-success',
            'view-order/admin-planorder/connected-cubi-casa-order-error',
            'view-order/admin-planorder/connected-cubi-casa-order-success',
            'view-order/admin-planorder/deleted-cubi-casa-order-error',
            'view-order/admin-planorder/deleted-cubi-casa-order-success',
            'view-order/admin-planorder/deliver-success',
            'view-order/admin-planorder/external-file-removed-success',
            'view-order/admin-planorder/generate-files-failed',
            'view-order/admin-planorder/generate-files-nothing-new',
            'view-order/admin-planorder/generate-files-success',
            'view-order/admin-planorder/grab-success',
            'view-order/admin-planorder/return/broker-failure',
            'view-order/admin-planorder/return/broker-success',
            'view-order/admin-planorder/return/roomsketcher-success',
            'view-order/admin-planorder/return/sketchup-success',
            'view-order/admin-planorder/return/success',
            'view-order/admin-planorder/returned-cubi-casa-order-error',
            'view-order/admin-planorder/returned-cubi-casa-order-success',
            'view-order/admin-planorder/roomsketcher-status-was-updated-successfully',
            'view-order/admin-planorder/send-to-plan-firm-error',
            'view-order/admin-planorder/send-to-plan-firm-success',
            'view-order/admin-planorder/sketchup-status-was-updated-successfully',
            'view-order/admin-planorder/sync-cubi-casa-order-error',
            'view-order/admin-planorder/sync-cubi-casa-order-success',
            'view-order/admin-planorder/update-placements-failed',
            'view-order/admin-planorder/update-placements-success',
            'view-order/basic-order-info/products/notifications/photographer-cant-handle-product',
            'view-order/basic-order-info/products/notifications/updated',
            'view-order/basic-order/modal/create-email/success-notification',
            'view-order/basic-order/modal/create-sms/success-notification',
            'view-order/copy-info/copywriter/selector/changed-copywriter',
            'view-order/copy-info/copywriter/selector/copywriter-reset',
            'view-order/move/failure',
            'view-order/move/success'
        ]
    },
    {
        path: '/order/:orderNumber',
        exact: false,
        keys: []
    },
    {
        path: '/orders-list/plans',
        exact: false,
        keys: []
    },
    {
        path: '/orders-list/photos',
        exact: false,
        keys: []
    },
    {
        path: '/orders-list/bookings',
        exact: false,
        keys: [
            'photographer-mail-modal/error',
            'photographer-mail-modal/success',
            'sms-modal/error',
            'sms-modal/success'
        ]
    },
    {
        path: '/orders-list/films',
        exact: false,
        keys: []
    },
    {
        path: '/orders-list/advance',
        exact: false,
        keys: ['orders/list/advance/toast/info/has-saved-filter']
    },
    {
        path: '/plantemplates',
        exact: false,
        keys: [
            'plan-templates/notification/error-file-upload',
            'plan-templates/notification/plan-template-added',
            'plan-templates/notification/plan-template-deleted',
            'plan-templates/notification/plan-template-updated'
        ]
    },
    {
        path: '/templates',
        exact: false,
        keys: []
    },
    {
        path: '/photographercalendar',
        exact: false,
        keys: [
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success'
        ]
    },
    {
        path: '/stylingcalendar',
        exact: false,
        keys: [
            'calendars/photographer-items/update/toastr/success',
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'photographers/calendar/toastr/error',
            'photographers/calendar/toastr/success'
        ]
    },
    {
        path: '/commontexts',
        exact: false,
        keys: [
            'common-texts/notification/common-text-added',
            'common-texts/notification/common-text-deleted'
        ]
    },
    {
        path: '/se360/photographerbooking',
        exact: false,
        keys: [
            'image-processing/notification/comment-updated',
            'orders/notification/order-created',
            'orders/notification/traveling-time-warning',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'se360/photographerbooking/page/toastr/success'
        ]
    },
    {
        path: '/se360/duskphotographybooking',
        exact: false,
        keys: ['orders/notification/order-created', 'se360/photographerbooking/page/toastr/success']
    },
    {
        path: '/scandphotos/photographerbooking',
        exact: false,
        keys: [
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'scandphotos/photographerbooking/toastr/error',
            'scandphotos/photographerbooking/toastr/success'
        ]
    },
    {
        path: '/se360/stylingbooking',
        exact: false,
        keys: [
            'image-processing/notification/comment-updated',
            'orders/notification/order-created',
            'orders/notification/traveling-time-warning',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'se360/photographerbooking/page/toastr/success'
        ]
    },
    {
        path: '/profile',
        exact: false,
        keys: ['profile/page/notification/profile-saved']
    },
    {
        path: '/brokeragents',
        exact: false,
        keys: [
            'broker-agent/create-message',
            'broker-agent/edit-message',
            'broker-agent/no-way-in/toast',
            'broker-agent/password-link/copied',
            'broker-agent/password-link/copy-failed',
            'broker-agent/password-link/email-sent',
            'broker-agent/password-link/email-sent-unknown-address',
            'broker-agent/password-link/error'
        ]
    },
    {
        path: '/calendars',
        exact: false,
        keys: [
            'calendars/photographer-items/update/toastr/success',
            'calendars/photographer-working-hours/update/toastr/success',
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'photographer-mail-modal/error',
            'photographer-mail-modal/success',
            'sms-modal/error',
            'sms-modal/success'
        ]
    },
    {
        path: '/stylingcalendars',
        exact: false,
        keys: [
            'calendars/photographer-items/update/toastr/success',
            'image-processing/notification/comment-updated',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success'
        ]
    },
    {
        path: '/404',
        exact: false,
        keys: []
    },
    {
        path: '/errors/iat-is-in-the-in-future',
        exact: false,
        keys: []
    },
    {
        path: '/photographeragreement',
        exact: false,
        keys: []
    },
    {
        path: '/imageeditorfirms',
        exact: false,
        keys: [
            'image-editor-firms/notification/image-editor-firm-added',
            'image-editor-firms/notification/image-editor-firm-updated'
        ]
    },
    {
        path: '/stylingfirms',
        exact: false,
        keys: [
            'styling-firms/notification/error/unable-to-fetch-data',
            'styling-firms/notification/styling-firm-added',
            'styling-firms/notification/styling-firm-updated'
        ]
    },
    {
        path: '/stylingusers',
        exact: false,
        keys: [
            'styling-user/notification/added',
            'styling-user/notification/updated',
            'styling-users/notification/error/unable-to-fetch-data'
        ]
    },
    {
        path: '/orders-list/photographer',
        exact: false,
        keys: []
    },
    {
        path: '/invoice',
        exact: false,
        keys: []
    },
    {
        path: '/invoices',
        exact: false,
        keys: ['invoice-history/create-payment-modal/notification/payment-saved']
    },
    {
        path: '/invoice-product-types',
        exact: false,
        keys: [
            'invoice-product-type/modal/notification/invoice-product-type-created',
            'invoice-product-type/modal/notification/invoice-product-type-edited'
        ]
    },
    {
        path: '/invoice-journals',
        exact: false,
        keys: []
    },
    {
        path: '/payment-journals',
        exact: false,
        keys: []
    },
    {
        path: '/photographer-invoice',
        exact: false,
        keys: []
    },
    {
        path: '/importexport',
        exact: false,
        keys: ['invoice/payments/import/feedback/ok']
    },
    {
        path: '/receivables',
        exact: false,
        keys: []
    },
    {
        path: '/unedited-orders',
        exact: false,
        keys: [
            'api/authentication/error/session-timed-out',
            'image-editor-firms/notification/error/unable-to-fetch-data',
            'unedited-orders/toastr/error'
        ]
    },
    {
        path: '/unedited-future-orders',
        exact: false,
        keys: []
    },
    {
        path: '/orderlist',
        exact: false,
        keys: [
            'order/plan/delivery-file/removed-successfully',
            'order/plan/error/delete',
            'order/plan/error/sort',
            'order/plan/error/storey',
            'plan/annotation/delivery-file/customer-errors/crop',
            'plan/annotation/external-file/customer-errors/crops',
            'plan/annotation/external-file/errors/crops',
            'planeditor/orders/edit/approve-plan-order-success',
            'planeditor/orders/edit/generate-files-failed',
            'planeditor/orders/edit/generate-files-nothing-new',
            'planeditor/orders/edit/generate-files-success',
            'planeditor/orders/edit/plan-editor/confirmation/error',
            'planeditor/orders/edit/plan-editor/confirmation/plan-editor-admin/success',
            'planeditor/orders/edit/plan-editor/confirmation/success',
            'planeditor/orders/list/grab-error',
            'plans/annotation/notifications/floor-successful-save',
            'plans/annotation/notifications/successful-save',
            'view-order/admin-planorder/update-placements-failed',
            'view-order/admin-planorder/update-placements-success'
        ]
    },
    {
        path: '/ordercollections/:orderCollectionId',
        exact: false,
        keys: ['image-processing/page/fail-update-sort-order']
    },
    {
        path: '/statistics',
        exact: false,
        keys: ['statistics/page/export/toastr/error', 'statistics/page/export/toastr/no-results']
    },
    {
        path: '/photographer-overview',
        exact: false,
        keys: []
    },
    {
        path: '/scandphotos/orders/new/:orderCollectionId?',
        exact: false,
        keys: [
            'image-processing/notification/comment-updated',
            'order/create/pickup-dialog/toaster-cancel',
            'order/create/pickup-dialog/toaster-confirm',
            'photographer-events/toastr/unbooking/error',
            'photographer-events/toastr/unbooking/success',
            'scandphotos/orders/create/toastr/error',
            'scandphotos/orders/create/toastr/success'
        ]
    },
    {
        path: '/favorite-images/:selectedImageId?',
        exact: false,
        keys: []
    },
    {
        path: '/imagegallery',
        exact: false,
        keys: []
    },
    {
        path: '/copywriters',
        exact: false,
        keys: ['copywriter/notification/added', 'copywriter/notification/updated']
    },
    {
        path: '/export-to-procountor',
        exact: false,
        keys: [
            'broker-agent/create-message',
            'broker-agent/edit-message',
            'broker-agent/no-way-in/toast',
            'broker-agent/password-link/copied',
            'broker-agent/password-link/copy-failed',
            'broker-agent/password-link/email-sent',
            'broker-agent/password-link/email-sent-unknown-address',
            'broker-agent/password-link/error',
            'brokers/firm/create-message',
            'brokers/firm/edit-message',
            'zentuvo-invoicing/error/no-results-found'
        ]
    },
    {
        path: '/news-editor',
        exact: false,
        keys: []
    },
    {
        path: '/feature-flags',
        exact: false,
        keys: []
    },
    {
        path: '/editing-styles',
        exact: false,
        keys: []
    },
    {
        path: '*',
        exact: false,
        keys: []
    }
];
